import { ButtonHTMLAttributes } from 'react'

import { LocalVideoTrack } from 'livekit-client'

import { VirtualBgHandler } from './VirtualBgHandler'

import { useLocalParticipant } from '@/src/hooks'

export interface VirtualBgHandlerWrapperProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export function VirtualBgHandlerWrapper() {
  const setCurrentBgEffect = (e) => {
    console.log(e)
  }

  const { cameraTrack } = useLocalParticipant()

  return (
    <div className="lk-bg-handler-wrapper">
      <VirtualBgHandler
        track={cameraTrack?.track as LocalVideoTrack}
        isPreJoin={false}
        changeBgEffect={(effect) => {
          setCurrentBgEffect(effect)
        }}
      />
    </div>
  )
}
